import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';
import type {TreeStructure} from '@pb/kit-component-tree-v2';
import type {DictionaryTree} from 'src/openapi/admin/models/DictionaryTree';

export const dictionaryTreeToTreeStructure = (data: Array<DictionaryTree>, disabled: boolean, prefix?: string):
TreeStructure => {
    return data.map(({id, description, children}) => ({
        id: prefix ? prefix + ':' + id : id,
        caption: description,
        disabled,
        children: children ? dictionaryTreeToTreeStructure(children, disabled, id) : undefined,
    }));
};

export const PLUGINS_AND_APPS = ['CHROME_EXTENSION', 'API', 'EXCEL_PLUGIN'];
export const getPluginsAndApps = <T extends {code: string}>(data: Array<T>): Array<T> => {
    return data.filter(e => PLUGINS_AND_APPS.includes(e.code));
};

export const getExportOptions = <T extends {code: string}>(data: Array<T>): Array<T> => {
    return data.filter(e => !PLUGINS_AND_APPS.includes(e.code));
};

export const updateHiddenFeatures = (
    hiddenFeatures: Array<string>,
    changeTreeType: ChangeTreeType,
): Array<string> => {
    if (hiddenFeatures.includes(`${changeTreeType.checkedId}`)) {
        return hiddenFeatures.filter(e => e !== `${changeTreeType.checkedId}`);

    }
    return [...hiddenFeatures, `${changeTreeType.checkedId}`];
};

export const getCheckedIds = <T extends {checked: boolean, code: string}>(data: Array<T>): Array<string> => {
    return data.filter(e => e.checked).map(e => e.code);
};
